import { useOutletContext } from 'react-router-dom';
import { Dashboard } from '../shell/Dashboard';
import { PasskeyOfferCard } from '../shell/PasskeyOffer';
import type { ShellOutletContext } from '../shell/AppShell';

/** The landing page at `/`, drawn from the tiles the shell resolved for this viewer. */
export function DashboardPage({ apiBaseUrl = '' }: { apiBaseUrl?: string }) {
  const { tiles, frameLoaded, hiddenTiles, queues, feed, personName, timeZone, todos, approvals, onArrange, passkeyOffer } = useOutletContext<ShellOutletContext>();
  return (
    <Dashboard
      tiles={tiles}
      loaded={frameLoaded}
      hiddenTiles={hiddenTiles}
      queues={queues}
      feed={feed}
      personName={personName}
      timeZone={timeZone}
      todos={todos}
      approvals={approvals}
      apiBaseUrl={apiBaseUrl}
      onArrange={onArrange}
      topCard={<PasskeyOfferCard offer={passkeyOffer} />}
    />
  );
}
